module.exports = __webpack_public_path__ + "static/img/topButton1.956a0a85.png";